<template>
  <div class="search-bar-container">
    <div class="search-input-box" @click="gotoSearch">
      <img src="@/assets/common/icon_search_new.png" class="search-icon-sys" />
      <van-swipe
        v-if="hotSearchList && hotSearchList.length > 0"
        class="search-swiper"
        vertical
        autoplay="3000"
        :show-indicators="false"
        @change="onSwiperChange"
      >
        <van-swipe-item
          v-for="(item, index) in hotSearchList"
          :key="index"
          class="search-swiper-item"
        >
          <div class="search-text">{{ item }}</div>
        </van-swipe-item>
      </van-swipe>
      <div v-else class="search-text">搜索商品</div>
    </div>
    <div class="search-right-icons">
      <div class="icon-container" @click="gotoCart">
        <img src="@/assets/common/icon_shopping_cart_new.png" class="right-icon" />
        <div v-if="cartCount > 0" class="badge">{{ cartCount }}</div>
      </div>
      <div class="icon-container" @click="gotoMsgCenter">
        <img src="@/assets/common/icon_message_new.png" class="right-icon" />
        <div v-if="msgtotalCount > 0" class="badge">{{ msgtotalCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    hotSearchList: {
      type: Array,
      default: () => []
    },
    cartCount: {
      type: Number,
      default: 0
    },
    msgtotalCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentKey: ""
    };
  },
  watch: {
    hotSearchList: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.currentKey = newVal[0];
        }
      }
    }
  },
  methods: {
    onSwiperChange(index) {
      if (this.hotSearchList && this.hotSearchList[index]) {
        this.currentKey = this.hotSearchList[index];
      }
    },
    gotoSearch() {
      const path = this.currentKey ? `/search?keywords=${encodeURIComponent(this.currentKey)}` : "/search";
      this.$router.push(path);
    },
    gotoCart() {
      this.$router.push("/cart");
    },
    gotoMsgCenter() {
      this.$toast("消息中心开发中...");
    }
  }
};
</script>

<style lang="less" scoped>
.search-bar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #fff;
  box-sizing: border-box;
  width: 100%;
}
.search-input-box {
  display: flex;
  align-items: center;
  flex: 1;
  background: #f7f8fa;
  border-radius: 18px;
  height: 36px;
  padding: 0 12px;
  box-sizing: border-box;
}
.search-icon-sys {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  object-fit: contain;
}
.search-swiper {
  height: 100%;
  flex: 1;
}
.search-swiper-item {
  display: flex;
  align-items: center;
  height: 100%;
}
.search-text {
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.search-right-icons {
  display: flex;
  align-items: center;
  margin-left: 12px;
}
.icon-container {
  position: relative;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
}
.badge {
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: #ee0a24;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  box-sizing: border-box;
}
</style>
